import React from "react";
import { useSelector } from "react-redux";
import Card from "./Card";

const Canvas = ({
  canvasContainerRef,
  postRef,
  _updateSelectedElement,
  selectedElement,
}) => {
  const {
    zoomLevel,
    view,
    pages,
    localProperties,
    globalProperties,
    data,
    layoutConfig,
    postVariant,
    bgFiles = [],
  } = useSelector((state) => state.grid);

  const canvasContainerClasses = `relative h-full p-4 bg-white overflow-auto flex-auto grid-bg flex gap-4 ${
    view === "col"
      ? "flex-col items-center justify-start"
      : "flex-wrap items-start justify-start"
  }`;

  const scalingContainerClasses = `transition-all duration-300 ease-in-out`;
  const cardContainerClasses = `flex flex-col items-start ${scalingContainerClasses}`;

  const cardContainerStyles = {
    transform: `scale(${zoomLevel})`,
    transformOrigin: "0% 0%",
  };

  const cardProps = {
    postRef,
    data,
    selectedElement,
    _updateSelectedElement,
    localProperties,
    globalProperties,
    layoutConfig,
    postVariant,
    bgFiles,
  };

  const scalingContainerStyles = {
    width: `${pages?.[0]?.containerWidth * zoomLevel}px`,
    height: `${pages?.[0]?.containerHeight * zoomLevel + 10}px`,
  };

  return (
    <div className={canvasContainerClasses} ref={canvasContainerRef}>
      {pages.map((page, idx) => (
        <div
          key={idx}
          className={scalingContainerClasses}
          style={scalingContainerStyles}
        >
          <div className={cardContainerClasses} style={cardContainerStyles}>
            <Card page={page} cardIdx={idx} {...cardProps} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Canvas;
